import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { isLoggedIn } from '@/lib/auth'
import { setUserContext, sentrySetup } from '@/lib/sentry'

Vue.config.productionTip = false

// UI components
import { loadComponents } from '@/lib/ui'
loadComponents()

sentrySetup(router)

if (isLoggedIn()) {
  setUserContext()
}

// Apollo / GraphQL
import { apolloProvider } from '@/lib/apollo'

new Vue({
  router,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')
